import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

// No-ops (and skips the network request the SDK would otherwise make) when
// SENTRY_DSN isn't set at build time, so local/preview builds work without a
// Sentry account.
if (SENTRY_DSN) {
  Sentry.init({ dsn: SENTRY_DSN, environment: SENTRY_ENVIRONMENT });
}

const container = document.getElementById('root')!;
createRoot(container).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

function ErrorFallback() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>Something went wrong. Please refresh the page.</p>
    </div>
  );
}
